export enum VendorSystemType {
  none = 'none',
  owasp = 'owasp',
  cbr = 'cbr',
  pci = 'pci',
}
